module.exports = __webpack_public_path__ + "files/0e2ad976e32180765a2f55789078b502.svg";